const messages = {
  title: "Bonus multiplikator",
  bandBonusTitle: "Bonus po gumi sa multiplikatorom",
  amountLabel: "Min. broj guma (*)",
  label: "Bonus multiplikator",
  desc: "Broj Bridgestone i Firestone guma. Nema bonusa u evrima na Firestone gume.",
  goals: {
    loyal: "Lojalan",
    bronze: "Bronza",
    silver: "Srebro",
    gold: "Zlato",
    platinum: "Platina",
  },
  andMore: "i više",
  chooseTarget: "Izaberi",
  selectTarget: "Izaberite svoj godišnji cilj za {year}:",
  multiplication: "Bonus se množi sa <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} guma",
};

export default {
  messages,
};
